/* GRWM motion v2: header height, scroll reveal (all pages), lazy-image fade, gothic text arrows, parallax (desktop).
   Transforms/opacity only, one IntersectionObserver, rAF-throttled. */
(function(){
  var d=document,h=d.documentElement;
  var M=window.GRWM_MOTION||{parallax:true,reveal:true,strength:1};
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop=window.matchMedia&&matchMedia('(min-width:991px) and (pointer:fine)').matches;

  var hd=d.getElementById('GrwmHeader');
  function headerH(){if(hd)h.style.setProperty('--g-header-h',hd.offsetHeight+'px');}
  headerH();
  if('ResizeObserver' in window&&hd)new ResizeObserver(headerH).observe(hd);

  /* ---- gothic arrows for text "→" in links/buttons (svg arrows are swapped in CSS) ---- */
  var AR=/[\u2192\u27F6\u279C\u279D]/,ARG=/\s*[\u2192\u27F6\u279C\u279D]/g;
  function arrows(root){
    if(!root||!root.querySelectorAll)return;
    var els=root.matches&&root.matches('a,button,.g-link')?[root]:root.querySelectorAll('a,button,.g-link');
    for(var i=0;i<els.length;i++){
      var el=els[i];if(!AR.test(el.textContent))continue;
      var w=d.createTreeWalker(el,4,null),list=[],n;
      while((n=w.nextNode()))if(AR.test(n.nodeValue))list.push(n);
      list.forEach(function(t){
        var parts=t.nodeValue.split(ARG),f=d.createDocumentFragment();
        parts.forEach(function(p,j){if(p)f.appendChild(d.createTextNode(p));if(j<parts.length-1){var g=d.createElement('i');g.className='g-garrow';g.setAttribute('aria-hidden','true');f.appendChild(g);}});
        t.parentNode.replaceChild(f,t);
      });
    }
  }

  /* ---- lazy images fade in once decoded (never touches eager/LCP images) ---- */
  function fade(root){
    var ims=(root.tagName==='IMG'?[root]:root.querySelectorAll?root.querySelectorAll('img[loading="lazy"]'):[]);
    for(var i=0;i<ims.length;i++){
      var im=ims[i];if(im.dataset.gf||im.getAttribute('loading')!=='lazy')continue;im.dataset.gf='1';
      if(im.complete&&im.naturalWidth)continue;
      if(getComputedStyle(im).opacity!=='1')continue;
      im.classList.add('gx-fade');
      (function(im){var done=function(){im.classList.add('is-ld');setTimeout(function(){im.classList.remove('gx-fade','is-ld');},600);};im.addEventListener('load',done,{once:true});im.addEventListener('error',done,{once:true});})(im);
    }
  }

  /* ---- scroll reveal ---- */
  var SPEC='.g-head-row,.g-card,.g-cats__card,.g-rev__card,.g-trust__cell,.g-gsplit__card,.g-insta__cell,.g-blog__card,.g-zip,.g-nl__l,.g-nl__r,.g-welcome__in,.g-bud__tile,.g-com__card,.g-cr__card,.g-look__stage,.g-look__panel,.g-nd__card,.g-vb__tabs,.g-reels__row,.g-info__card,.g-cart__line,.g-cart__sum,.g-pdp__extra,.g-pdp__rel,.g-srch__empty';
  var GEN='.g-root > *';
  var io=null;
  function mark(el,mode,vh){
    el.dataset.rv='1';if(mode==='none')return;
    if(el.getBoundingClientRect().top<vh*0.92)return; /* already on screen: no flash */
    var p=el.parentElement,idx=p?Array.prototype.indexOf.call(p.children,el):0;
    el.style.transitionDelay=(Math.min(idx%6,5)*60)+'ms';
    el.classList.add('g-rv','g-rv--'+mode);
    io.observe(el);
  }
  function modeOf(el){var s=el.closest('.shopify-section');return (s?getComputedStyle(s).getPropertyValue('--g-reveal').trim():'')||'fade-up';}
  function scan(root){
    if(!io)return;root=root||d;var vh=innerHeight,i,el;
    var a=root.querySelectorAll(SPEC);
    for(i=0;i<a.length;i++){el=a[i];if(el.dataset.rv||el.closest('[data-no-reveal],#header-group'))continue;mark(el,modeOf(el),vh);}
    var b=root.querySelectorAll(GEN);
    for(i=0;i<b.length;i++){
      el=b[i];if(el.dataset.rv||el.closest('[data-no-reveal],#header-group'))continue;
      var tn=el.tagName;if(tn==='STYLE'||tn==='SCRIPT'||tn==='TEMPLATE'||tn==='FORM'&&!el.offsetHeight||el.hidden){el.dataset.rv='1';continue;}
      if(el.querySelector(SPEC)||el.matches('.g-col__bar')){el.dataset.rv='1';continue;}
      var cs=getComputedStyle(el);if(cs.position==='sticky'||cs.position==='fixed'||cs.display==='contents'||el.offsetHeight>vh*1.3){el.dataset.rv='1';continue;}
      mark(el,modeOf(el),vh);
    }
  }

  function boot(){
    arrows(d.body);fade(d);
    if(!reduce&&M.reveal!==false&&'IntersectionObserver' in window){
      io=new IntersectionObserver(function(es){for(var i=0;i<es.length;i++){if(es[i].isIntersecting){var tg=es[i].target;tg.classList.add('is-in');io.unobserve(tg);setTimeout(function(x){x.style.transitionDelay='';}.bind(null,tg),1000);}}},{rootMargin:'0px 0px -6% 0px',threshold:0});
      /* elements that already carry .g-rv in their markup (e.g. Recently Viewed) must be observed too, or they stay invisible */
      var pre=d.querySelectorAll('.g-rv:not(.is-in)');
      for(var p=0;p<pre.length;p++){if(!pre[p].dataset.rv){pre[p].dataset.rv='1';io.observe(pre[p]);}}
      scan();
    }else{
      var all=d.querySelectorAll('.g-rv');
      for(var a=0;a<all.length;a++)all[a].classList.add('is-in');
    }
    /* new content (cart drawer, recently viewed, size sheet, filters) gets arrows + fades too */
    if('MutationObserver' in window){
      var q=[],t=0;
      new MutationObserver(function(ms){
        for(var i=0;i<ms.length;i++){var ad=ms[i].addedNodes;for(var j=0;j<ad.length;j++){if(ad[j].nodeType===1&&!ad[j].classList.contains('g-garrow'))q.push(ad[j]);}}
        if(q.length&&!t)t=requestAnimationFrame(function(){t=0;var l=q;q=[];for(var k=0;k<l.length;k++){if(l[k].isConnected){arrows(l[k]);fade(l[k]);}}});
      }).observe(d.body,{childList:true,subtree:true});
    }
  }
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',boot);else boot();
  d.addEventListener('shopify:section:load',function(e){arrows(e.target);fade(e.target);scan(e.target);});

  /* ---- parallax (desktop only) ---- */
  if(!reduce&&M.parallax&&desktop){
    var items=[],k=0.06*(M.strength||1),ticking=false;
    var collect=function(){items=[].slice.call(d.querySelectorAll('.g-hero__media img,.g-gsplit__bg img,.g-cats__bg img,[data-parallax]'));};
    var run=function(){
      ticking=false;var vh=innerHeight;
      for(var i=0;i<items.length;i++){
        var el=items[i],p=el.parentElement;if(!p)continue;
        var r=p.getBoundingClientRect();if(r.bottom<-50||r.top>vh+50)continue;
        el.style.transform='translate3d(0,'+((r.top+r.height/2-vh/2)*-k).toFixed(1)+'px,0) scale(1.12)';
      }
    };
    collect();run();
    addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(run);}},{passive:true});
    d.addEventListener('shopify:section:load',function(){collect();run();});
  }
})();
